<template>
<div class="fk-head">
 <el-tabs v-model="activeName"  type="border-card">
  <el-tab-pane name="first">
    <span slot="label"><i class="el-icon-s-platform"></i><label>来访记录</label></span>
     <my-lfjl></my-lfjl>
  </el-tab-pane>
  <el-tab-pane name="second">
    <span slot="label"><i class="el-icon-s-data"></i><label>来访统计</label></span>
    <my-lftj></my-lftj>
  </el-tab-pane>
 <el-tab-pane name="third">
    <span slot="label"><i class="el-icon-user-solid"></i><label>黑白名单</label></span>
     <my-hbmd></my-hbmd>
  </el-tab-pane>
   <el-tab-pane name="fourth">
    <span slot="label"><i class="el-icon-phone-outline"></i><label>内部通讯录</label></span>
     <my-nbtxl></my-nbtxl>
  </el-tab-pane>
</el-tabs>
</div>
</template>
<script>

import lfjl from "@/views/fksys/lfjl";//来访记录
import lftj from "@/views/fksys/lftj";//来访统计
import hbmd from "@/views/fksys/hbmd"; //黑白名单
import nbtxl from "@/views/fksys/nbtxl"; //内部通讯录

export default {
   components: {
    "my-lfjl": lfjl,
     "my-lftj": lftj,
      "my-hbmd": hbmd,
       "my-nbtxl": nbtxl,
  },
  data() {
    return {
      user:{},
     activeName: 'first'
    };
  },
  props:{
    activeIndex: 0
  },
  mounted(){
   this.user=JSON.parse(window.localStorage.user);
  },
  methods: {
     handleClick(tab, event) {
        console.log(tab, event);
      }
  }
};
</script>
<style scoped>
.el-menu--horizontal .el-menu-item
{
  height:40px !important;
  line-height:40px !important;;
}
</style>



// WEBPACK FOOTER //
// src/views/fksys/otherMgr.vue